import * as actions from "./EventCardActions";
import {EVENT_CARD_RECORDINGS_LIST} from "./EventCardActions";

const initialState = {
  isLoadingPage: true,
  channel: {},
  contentData: {},
  event: {}
};

export default function card(state = initialState, action) {
  switch (action.type) {
    case actions.EVENT_CARD_IS_LOADING_PAGE:
      return { ...state, ...{ isLoadingPage: action.isLoadingPage } };
    case actions.EVENT_CARD_SET_EPG_CHANNELS:
      return { ...state, ...{ event: action.event } };
    case actions.EVENT_CARD_SET_LINEAL_CHANNELS:
      return { ...state, ...{ channel: action.channel } };
    case actions.EVENT_CARD_SET_CONTENT_DATA:
      return { ...state, ...{ contentData: action.contentData } };
    case actions.EVENT_CARD_RECORDINGS_DATA:
          return { ...state, ...{ recordings_data: action.recordings_data } };
    default:
      return state;
  }
}
